import React, { useState, useEffect } from 'react';
import { Modal, FormGroup, Button, Form, Input, Card, CardBody, CardHeader, CardFooter, Col, Row, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import reactCSS from 'reactcss';
import { useAlert } from 'react-alert'
import './login.css';
// import {COLORS} from '../../utils//color.js'
import general_fetch from '../utils/fetch';
import GoogleAuth from '../GoogleAuth'
import Search from '../components/Search';
import build_path from '../utils/build_path';
import { NetworkError } from '../utils/errors';
import { user_has_access_to_portal } from '../utils/user';

let login_method = '';

const styles =  reactCSS({
    'default': {
        main_div:{
            // background: 'url("/resources/images/site_image.jpeg") 50% fixed',
            height: '100vh',
            width : '100%',
            position: 'relative',
            backgroundSize: 'cover',
            overflow: 'hidden',
            backgroundColor:'white'

        },
        layer: {
            width: '100%',
            height: '100vh',
            position: 'absolute',
            left: '0',
            top: '0',
            // background: 'white'
        },
        modal_size_sm:{
            maxWidth:'350px !important'
        }
    },
});

const Store_options_modal = ({open, handle_close, all_store_options, onclick_store, user_id}) => {

    // let professional_stores;
    // let business_stores;

    const [professional_stores, set_professional_stores] = useState([]);
    const [business_stores, set_business_stores] = useState([]);
    const [display_business_stores, set_display_business_stores] = useState([]);
    
    useEffect(() => {
        if(all_store_options && all_store_options.length){
            set_professional_stores(all_store_options.filter(x => x.type == 'professional'));
            set_business_stores(all_store_options.filter(x => x.type == 'business'));
        }
        // console.log("stores", professional_stores, business_stores)
    }, [all_store_options]);

    const onclick_handleclose = () => {
        handle_close()
    }

    const onclick_single_store = (selected_store) => {
        onclick_store(selected_store)
        onclick_handleclose()
    }

    useEffect(() => {
        console.log("stores", professional_stores, business_stores)
        set_display_business_stores(business_stores)
    }, [business_stores]);

    return(
        <Modal className="modal-dialog-centered" size="md" isOpen={open} toggle={onclick_handleclose}>
            <Card className='store_options_card'>
                <CardHeader style={{display:'flex', alignItems:'center', justifyContent:'space-between', fontSize:'16px', fontWeight:600}}>
                    <div>Sign-in with Infurnia</div>
                    <i style={{cursor:'pointer'}} onClick={onclick_handleclose} className='fa fa-times'/>
                </CardHeader> 
                <CardBody style={{padding:0}}> 
                    <div style={{padding:'20px', fontSize:'16px', fontWeight:600, textAlign:'center'}}>
                        <div>Choose Organization</div>
                    </div>
                    <div style={{padding:'20px 20px 10px 20px', fontSize:'14px', display:'flex', alignItems:'center', justifyContent:'space-between'}}>
                        <div>Org Accounts</div>
                    </div>
                    <Search list={business_stores} set_list={set_display_business_stores} search_value={'name'}></Search>
                    <div className='all_store_options_div' id="all_store_options_div">
                        {
                            display_business_stores && display_business_stores.length ? display_business_stores.map((item, idx)=>
                                <div id={item.id} title={item.name} className='single_store' onClick={()=>onclick_single_store(item)} key={idx} style={{cursor:'pointer'}}>
                                    <i className='fa fa-user-circle-o single_store_icon'/>
                                    <div className='single_store_text'>{item.name} <span style={{color:'#BEBEBE'}}>{item.user_id === item.master_admin_id ? '(Master)' : ''}</span></div>
									<div className='ml-2 premium_tag flex_center' style={{backgroundColor:!item.premium_customer ? (!item.suspended ? '#E6E9EE' : '#F9DADE') : '', color:!item.premium_customer ? (!item.suspended ? '#676878' : '#FF5247') : ''}}>{item.premium_customer ? 'Premium' : (!item.suspended ? 'Trial' : 'Suspended')}</div>
                                </div>
                            )
                            :<div className='flex_center' style={{padding:'0px 20px 20px 20px', color:'gray'}}>No Organizations to list</div>
                        }
                    </div>
                    <div style={{padding:'20px 20px 10px 20px', fontSize:'14px', display:'flex', alignItems:'center', justifyContent:'space-between'}}>
                        <div>Professional Accounts</div>
                    </div>
                    <div className='all_store_options_div'>
                        {
                            professional_stores && professional_stores.length?professional_stores.map((item, idx)=>
                                <div id={item.id} title={item.name} className='single_store' onClick={()=>onclick_single_store(item)} key={idx} style={{cursor:'pointer'}}>
                                    <i className='fa fa-user-circle-o single_store_icon'/>
                                    <div className='single_store_text'>{item.name}</div>
                                </div>
                            )
                            :<div className='flex_center' style={{padding:'0px 20px 20px 20px', color:'gray'}}>No Professional Accounts to list</div>
                        }
                    </div>
                </CardBody>
            </Card>
        </Modal>
    )
}

const Business_units_modal = ({open, handle_close, business_unit_options, onclick_business_unit, selected_store, all_bu_options}) => {

    const onclick_handleclose = () => {
        handle_close()
    }

    return(
        <Modal className="modal-dialog-centered" size="md" isOpen={open} toggle={onclick_handleclose}>
            <Card className='store_options_card'>
                <CardHeader style={{display:'flex', alignItems:'center', justifyContent:'space-between', fontSize:'16px', fontWeight:600}}>
                    <div>Sign-in with Infurnia</div>
                    <i style={{cursor:'pointer'}} onClick={onclick_handleclose} className='fa fa-times'/>
                </CardHeader> 
                <CardBody style={{padding:0}}> 
                    <div style={{padding:'20px', fontSize:'16px', fontWeight:600, textAlign:'center'}}>
                        <div>Choose Business Unit</div>
                    </div>
                    <div className='all_store_options_div' id="all_business_unit_options_div">
                    {
                        business_unit_options && business_unit_options.length ? business_unit_options.map((business_unit, idx) => (
                            <div /*id={business_unit.id} title={business_unit.name}*/ className='single_store' onClick={()=>onclick_business_unit(business_unit, selected_store)} key={idx} style={{cursor:'pointer'}}>
                                <i className='fa fa-user-circle-o single_store_icon'/>
                                <div className='single_store_text'>{business_unit && all_bu_options && all_bu_options[business_unit] && all_bu_options[business_unit].name ? all_bu_options[business_unit].name : business_unit}</div>
                            </div>
                        )):<div className='flex_center' style={{padding:'0px 20px 20px 20px', color:'gray'}}>No Business units to list</div>
                    }
                    </div>
                </CardBody>
            </Card>
        </Modal> 
    )
}

const Info_Modal = ({  open, handle_close,  info }) => {

	return(
		<Modal className="modal-dialog-centered" size="md" isOpen={open} toggle={handle_close}>
			<ModalBody style={{backgroundColor:'#FFFFFF', borderRadius: '4px', padding:'36px 16px'}}>
				<div style={{textAlign:'center'}}>{info}</div>
			</ModalBody>
		</Modal>
	)    
}


const Multilogin_alert_modal = ({ open, handle_close }) => {

	return(
		<Modal className="modal-dialog-centered" size="md" isOpen={open} backdrop="static" keyboard={false} labelledBy="multilogin_alert_text">
			<ModalBody style={{backgroundColor:'#FFFFFF', borderRadius: '4px', padding:'36px 16px'}}>
				<div id="multilogin_alert_text" style={{textAlign:'center'}}>You were logged out since the same account is being used in parallel on the same or a different computer. Change your password if you think some other user is also using it</div>
			</ModalBody>
			<ModalFooter style={{justifyContent:'center'}}>
				<Button className='btn_login' onClick={handle_close} style={{width:'100px', backgroundColor:'#0078ff', border:0, fontWeight:'bold'}} type="button">OK</Button>
			</ModalFooter>
		</Modal>
	)
}

const Forgot_password_modal = ({ open, handleclose, set_page_loader}) => {

    const alert = useAlert()
    const [email_id_for_link, set_email_id_for_link] = useState('')
    const [error_text, set_error_text] = useState('')

    const onclick_handleclose = () => {
        set_email_id_for_link('');
        handleclose();
    }

    const validate_email = () => {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email_id_for_link);
    }

    const clean_Fp_data = () =>{
        set_email_id_for_link('')
    }

    const onclick_send_reset_link = async() => {
        if(!validate_email()){
            set_error_text('Incorrect Email Id');
            alert.error('Please enter correct Email Id.');
        }else{
            try{
                var body={email_or_username:email_id_for_link}
                set_page_loader({
                    show: true,
                    text: 'Sending password reset link...'
                });
                var resp = await general_fetch({url:'/user/init_forgot_password', body, return_response_code:true});
                set_page_loader({
                    show: false,
                    text: ''
                });
                if(resp && resp.response_code===1){
                    window.analytics.track("auto", {
                        "email": email_id_for_link,
                        "category": "reset_password"
                    })
                    alert.success('Reset password link sent successfully.')
                    onclick_handleclose()
                }else if(resp && resp.code){
                    if(resp.code == "USER_NOT_SIGNED_UP"){
                        alert.error('Email not registered. Please Sign up.')
                        onclick_handleclose()
                    }
                }
                clean_Fp_data();
        }catch(err){
            console.log(err)
            alert.error('Request Failed!')
            clean_Fp_data()
            set_page_loader({
                show: false,
                text: ''
            });
        }
        }

    }
    
    return(
        <Modal className="modal-dialog-centered" size="md" isOpen={open} toggle={onclick_handleclose}>
            {/* <Card style={{}}>
                <CardHeader>
                    <Row>
                        <Col>
                            Find your Account
                        </Col>
                        <Col style={{textAlign:'right'}}>
                            <span style={{cursor:'pointer'}} onClick={onclick_handleclose}>×</span>
                        </Col>
                    </Row>
                </CardHeader> 
                <CardBody>           
                    <Row style={{paddingBottom:'5px'}}>
                        <Col className="text-muted">
                            <span className='sign_up_text_color'>Please enter your Email Id</span>
                        </Col>
                    </Row>
                    <Row style={{paddingBottom:'30px'}}>
                        <Col>
                            <Input value={email_id_for_link} onChange={(e) => set_email_id_for_link(e.target.value)} style={{fontSize:'12px'}} placeholder='Email'  type='text'/>
                        </Col>
                    </Row> */}
                    {/* <Row style={{display:error_text?'block':'none',paddingBottom:'30px'}}>
                        <Col>
                            <span>{error_text}</span>
                        </Col>
                    </Row> */}
                {/* </CardBody> 
                <CardFooter>   
                    <Row>    
                        <Col style={{ textAlign:'right'}}>
                            <Button onClick={onclick_send_reset_link} className='blue_button' style={{ whiteSpace:'nowrap'}}>Send Reset Link</Button>
                        </Col>
                    </Row>
                </CardFooter>
                
            </Card> */}
            <ModalHeader style={{ backgroundColor:'white', color:'black', height:'60px', boxShadow:'0px 1px 12px rgba(0, 0, 0, 0.1)'}} toggle={onclick_handleclose}>Find your Account</ModalHeader>
            <ModalBody style={{padding:'40px'}}>
                <div className='light_text' style={{marginBottom:'10px', fontSize:'14px'}}>Please enter your Email Id</div>
                <Input value={email_id_for_link} onChange={(e) => set_email_id_for_link(e.target.value)} style={{fontSize:'16px', height:'48px'}} placeholder='Email'  type='text'/>
            </ModalBody>
            <ModalFooter style={{border:'0', marginBottom:'32px', marginRight:'16px'}}>
                <Button onClick={onclick_send_reset_link} style={{ whiteSpace:'nowrap', backgroundColor:'#4597F7', border:'0', height:'40px', fontSize:'16px', padding:'8px 12px'}}>Send Reset Link</Button>
            </ModalFooter>
        </Modal>
    )    
}

const NoDesignerAccessModal = ({open, handle_close, selected_store, logout}) => {
    const alert = useAlert()
    const set_store_fn = async() => {
        try{
            var resp_onclick_store = await general_fetch({url:'/user/set_active_store', body:{selected_store_id:selected_store.id}})
            alert.success('Successfully signed into ' + selected_store.name)
            console.log('')
            window.location.href = global.config.admin_path
        }catch(err){
            alert.error('Error in Logging into selected store')
            console.log(err)
        }
    }

    useEffect(() => {   
        console.log('NoDesignerAccessModal')
    }, [open]);

    return(
        <Modal isOpen={open} size='md' onClose={handle_close} style={{height:'150px', width:'360px', marginTop:'17%'}}>
            <Card>
                <div style = {{backgroundColor:'#F5F6F8', overFlow:'auto', padding:'5%', fontSize:'15px'}}> 
                    <div style = {{padding:'16px 2px 10px 16px'}}>You don't have access to design portal in <span>"{selected_store ? selected_store.name : ''}"</span> organization.</div>
                    <div style = {{padding:'4px 0px 10px 16px', color:'#1588E0', textDecoration:'underline',}}><span onClick={() => set_store_fn()} style={{cursor:'pointer'}}>Go to Admin Portal</span></div>
                    <div style={{display:'flex', padding:'10px 20px', justifyContent:'center'}}>
                        {/* <Button className='white_button' type="button" onClick={() => {handle_close()}}>Cancel</Button> */}
                        <Button className='white_button' type="button" onClick={() => {handle_close(); logout()}}>Close</Button>
                    </div>
                </div>
            </Card>
        </Modal>
    )
}


const Sign_up = ({org_key, user_details, set_user_details, set_page_loader, org_key_logo, org_key_id, org_key_name, login_modal_type, set_login_modal_type}) => {

    const alert = useAlert()
    var SHA512 = require('js-sha512')
    
    const [login_state, set_login_state] = useState('signin')
    //const [target, set_target] = useState('')
    const [target_type, set_target_type] = useState('')
    const [target_path, set_target_path] = useState('')

    const [ email, set_email ] = useState("");
    const [ password, set_password] = useState("");

    const [ loaded, set_loaded ] = useState(false);

    const [show_forgot_password_modal, set_show_forgot_password_modal] = useState(false)

    const [show_info_modal, set_show_info_modal] = useState(false);
    const [show_multilogin_modal, set_show_multilogin_modal] = useState(false);
    const [info_message, set_info_message] = useState('');

    const [show_store_options_modal, set_show_store_options_modal] = useState(false)
    const [all_store_options, set_all_store_options] = useState([])
    const [all_bu_options, set_all_bu_options] = useState([]);

    const [ google_social_login_script_loaded, set_google_social_login_script_loaded ] = useState(false);
    const [ google, set_google ] = useState(null);

    const [is_user_loaded, set_is_user_loaded] = useState(false);
    const [user_id, set_user_id] = useState('');

    // const [show_no_designer_access_modal, set_show_no_designer_access_modal] = useState();
    const [selected_store, set_selected_store] = useState();

    const [show_password_normal, set_show_password_normal] = useState(false);

    const [business_unit_options, set_business_unit_options] = useState([]);
    const [show_business_units_modal, set_show_business_units_modal] = useState(false);

    let param = new URLSearchParams(document.location.search)
    let target = param.get("target")
    let path = param.get("path")
    let sales_env = param.get("sales_env")
    useEffect(() => {
        console.log('modal window', login_modal_type)
        window.analytics.page("auto", {
            "page": login_modal_type
        })
    }, [login_modal_type]);
    
    useEffect(() => {
        console.log("target", target)

        if(target === "social_signup"){
            set_login_modal_type("new_to_inf")
            // login_init (which shows the page) only runs once a target path is set
            set_target_path(build_path(window.location.origin , 'portals'));
        }else if(target === "admin"){
            set_target_type('admin')
            let _target_path = (build_path(global.config.admin_path.replace('com', window.location.origin.split('.')[2]) , (path ? path : '')))
            if (!window.location.origin.includes("infurnia.com")) {
                _target_path = _target_path.replace('infurnia', org_key)
            }
            set_target_path(_target_path);

        }else if(target === "csp"){
            set_target_type('sales')
            set_target_path(build_path(global.config.sales_path, (path ? path : '')))

        }else if(target === "sales"){
            set_target_type('sale')
            let sale_base_url = 'https://sales.infurnia.com'
            if(sales_env === 'stage'){
                sale_base_url = 'https://stage.sales.infurnia.com'
            }else if(sales_env === 'dev'){
                sale_base_url = 'https://dev.sales.infurnia.com'
            }
            set_target_path(build_path(sale_base_url, (path ? path : '')))

        }else if(target === "bdp"){
            set_target_type('bdp')
            set_target_path(build_path(global.config.bdp_path, (path ? path : '')))

        }else if(target === "mes"){
            set_target_type('mes')
            set_target_path(build_path(global.config.mes_path, (path ? path : '')))

        }else if(target === "affiliate"){
            set_target_type('affiliate')
            set_target_path(build_path(global.config.affiliate_path, (path ? path : '')))

        }else if(target === "design"){
            set_target_type('design');
            let _target_path = (build_path(global.config.design_path.replace('com', window.location.origin.split('.')[2]) , (path ? path : '')))
            if (!window.location.origin.includes("infurnia.com")) {
                _target_path = _target_path.replace('infurnia', org_key)
            }
            set_target_path(_target_path);
        }else{
            set_target_type('');
            set_target_path(build_path(window.location.origin , 'portals'));
        }

        if(window.location.href.includes('e=multilogin')){
            set_show_multilogin_modal(true)
        }
        if(window.location.href.includes('e=user_role_insufficient')){
            alert.error("User does not have required role")
        }
    },[target]);

    useEffect(() => {
        console.log("target path print", target_path)
        if(target_path){
            login_init();
        }
    }, [target_path]);

    

    const load_google_auth_script = async src => {
        return new Promise((resolve, reject) => {
            if (document.querySelector(`script[src="${src}"]`)) return resolve()
            const script = document.createElement('script')
            script.src = src
            script.async = true;
            script.defer = true;
            script.onload = () => resolve(true)
            script.onerror = (err) => reject(err)
            document.body.appendChild(script)
        });
    }

    const initialize_social_login = async () => {
        await load_google_auth_script('https://accounts.google.com/gsi/client');
        // console.log("inside 54 google social login script loaded", window.google)
        set_google_social_login_script_loaded(true);
        set_google(window.google);
    }

    const route_finder = async(attached_stores) => {
        console.log('workspaces----------------------')
        try{
            var checking_response = await general_fetch({url:'/user/get_details', data_field:'user'});
            // console.log("User details loaded 2", checking_response)
            if(checking_response){
                set_user_details(checking_response.user_details)
                // console.log('user details loaded done')
            }
            if(checking_response['user_details'] && checking_response['user_details']['orphan'] == 1){
                set_is_user_loaded(true)
                set_login_modal_type('new_to_inf')
                return
            }
            if(checking_response && checking_response != "error" && checking_response != "unauthorized"){
                set_is_user_loaded(true)
                set_user_id(checking_response['user_details']['id'])
                if(org_key && org_key_id != ""){
                    // var resp_store_details = await general_fetch({url:'/user/get_attached_stores'});
                    var resp_store_details = attached_stores;
                    set_all_bu_options(resp_store_details.business_units)
                    if(resp_store_details.stores && resp_store_details.stores.length>0){
                        var store_find = resp_store_details.stores.find(o => o.id == org_key_id)
                        if(store_find){
                            var resp_onclick_store = await general_fetch({url:'/user/set_active_store', body:{selected_store_id:org_key_id}})
                            let resp_user_details = await general_fetch({url:'/user/get_details', data_field :'user'})
                            if(resp_user_details.user_details.business_unit_ids && resp_user_details.user_details.business_unit_ids.length == 1){
                                onclick_business_unit(resp_user_details.user_details.business_unit_ids[0], store_find)
                            }else if(!resp_user_details.user_details.business_unit_ids || resp_user_details.user_details.business_unit_ids.length == 0){
                                alert.error("You are not part of this organization")
                            }else{
                                set_business_unit_options(resp_user_details.user_details.business_unit_ids)
                                set_show_business_units_modal(true)
                            }
                            // redirect_to_target_final();
                        }else{
                            alert.error("You don't have an account in " + org_key_name)
                            logout();
                        }
                    }
                }else{
                    set_page_loader({show:true, text: "Fetching Organization Info..."})
                    // var resp_store_details = await general_fetch({url:'/user/get_attached_stores'})
                    var resp_store_details = attached_stores;
                    if(resp_store_details.stores && resp_store_details.stores.length>0){
                        // console.log('get_attached_stores', resp_store_details.stores)
                        set_all_store_options(resp_store_details.stores)
                        set_all_bu_options(resp_store_details.business_units)
                    }
                    set_page_loader({show:false, text: "Please Wait..."})

                    // else{
                    //     redirect_to_target_final();   
                    // }
                }
            }else{
                redirect_to_target_final();
            }
        }catch(err){
            alert.error('Error in fetching details for Stores')
            console.log(err)
        }
    } 

    const login_init = async () => {
        try{
            // console.log("inside login init try")
            //TODO response needs to be as per core 
            set_page_loader({
                show: true,
                text: 'Loading'
            });
            // console.log("User details loaded 1")
            var response = await general_fetch({url:'/user/get_details', return_raw_response:true});
            set_page_loader({
                show: false,
                text: 'User Details Found. Redirecting...'
            });
            
            console.log("inside login init try response", response)
            if(response['response_code'] == 1 && response['user'] && response['user']['user_details'])set_user_details(response['user']['user_details'])
            //TODO handle orphan case
            if(response['response_code'] == 1 && response['user'] && response['user']['user_details'] && response['user']['user_details']['orphan'] != 1 && response['user']['user_details']['id'] != 6){
                console.log("is redirecting to final ?")
                // set_loaded(true);
                await redirect_to_target_final();
            } else if(response['response_code'] == 1 && response['user'] && response['user']['user_details'] && response['user']['user_details']['orphan'] == 1){
                console.log("is redirecting to final 1?")
                set_loaded(true);
                set_is_user_loaded(true)
                set_login_modal_type('new_to_inf')
            }else{
                set_loaded(true);
            }

            return response;
        }catch(err){
            console.log(err);
            return "error";
            // return Promise.reject(err);
        }
    }

    const redirect_to_target_final = async () => {
        let resp_user_details = await general_fetch({url:'/user/get_details', data_field :'user'})
        user_details = resp_user_details.user_details
        set_user_details(user_details)
        try {
            window.analytics.track("auto", {
                "user_id": user_details && user_details.id,
                "email": user_details && user_details.email,
                "method": login_method,
            })

            let final_target_path = target_path;

            
            if(target_type === 'sale'){
                // sale redirect — skip role validation, use target_path as-is
            }else if(target_type){
                if(!user_has_access_to_portal(user_details, target_type)){
                    final_target_path = build_path(window.location.origin , 'portals')
                }
            }else{
                let count=0;
                let portal_type;
                ['admin', 'design', 'mes'].map((portal) => {
                    if(user_has_access_to_portal(user_details, portal)){
                        count++;
                        portal_type = portal
                    }
                })

                if (count == 1) {
                    if (portal_type == 'mes') {
                        final_target_path = global.config.mes_path
                    } else {
                        let _target_path = (build_path(global.config[`${portal_type}_path`].replace('com', window.location.origin.split('.')[2])))
                        if (!window.location.origin.includes("infurnia.com")) {
                            _target_path = _target_path.replace('infurnia', org_key)                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                       
                        }
                        final_target_path = _target_path;
                    }
                }
            }



            window.location.href = final_target_path

        } catch (err) {
            console.log(err)
            alert.error("Failed to get your details. Try again in sometime")

        }
    }

    useEffect(() => {
        if(all_store_options && all_store_options.length > 1){
            set_show_store_options_modal(true)
        }else if(all_store_options && all_store_options.length === 1){
            onclick_store(all_store_options[0])
        }
    },[all_store_options])

    const onclick_store = async(selected_store) => {
        try{
            console.log("selected store" , selected_store)
            set_selected_store(selected_store)
            // if(!(selected_store.roles.includes("designer")) && target_type != 'admin' && target_type != 'affiliate'){
            //     console.log("selected store 1" , selected_store)
            //     set_show_no_designer_access_modal(true)
            //     return
            // }
            let resp_onclick_store = await general_fetch({url:'/user/set_active_store', body:{selected_store_id:selected_store.id}})
            let resp_user_details = await general_fetch({url:'/user/get_details', data_field :'user'})
            if(resp_user_details && resp_user_details.user_details){
                set_user_details(resp_user_details.user_details)
                set_business_unit_options(resp_user_details.user_details.business_unit_ids)
                if(resp_user_details.user_details.business_unit_ids && resp_user_details.user_details.business_unit_ids.length == 1){
                    onclick_business_unit(resp_user_details.user_details.business_unit_ids[0], selected_store)
                }else if(!resp_user_details.user_details.business_unit_ids || resp_user_details.user_details.business_unit_ids.length == 0){
                    alert.error("You are not part of this organization")
                }else{
                    set_show_business_units_modal(true)
                }
            }
        }catch(err){
            alert.error('Error in Logging into selected store')
            console.log(err)
        }
    }

    const onclick_business_unit = async(business_unit_id, selected_store) => {
        try{    
            let resp = await general_fetch({url:'/user/set_current_business_unit', body:{business_unit_id}})
            alert.success('Successfully signed in')
            redirect_to_target_final()
        }catch(err){
            alert.error('Error in Logging into selected business unit')
            console.log(err)
        }
    }

    const close_store_options_modal = () => {
        set_show_store_options_modal(false)
        set_all_store_options([])
    }

    useEffect(()=> {
        console.log("constructor")
        initialize_social_login();

        window.enter_signup = (key) => {
            if(key == 'need_new_infurnia_account'){
                set_login_modal_type('new_to_inf');
                set_login_state('signup')
            }
        }
        // window.onSignIn = onSignIn

        return () => {
            delete window.enter_signup;
        };


    },[])

    // {
    //     "ip": "49.207.198.175",
    //     "hostname": "broadband.actcorp.in",
    //     "city": "Bengaluru",
    //     "region": "Karnataka",
    //     "country": "IN",
    //     "loc": "12.9719,77.5937",
    //     "org": "AS24309 Atria Convergence Technologies Pvt. Ltd. Broadband Internet Service Provider INDIA",
    //     "postal": "560002",
    //     "timezone": "Asia/Kolkata",
    //     "readme": "https://ipinfo.io/missingauth"
    //   }%  

    const logout = async () => {
        try {
            await general_fetch({ url: '/user/logout' })
            window.location.href = global.config.auth_redirect_path;
        } catch (err) {
            console.log(err)
        }
    }


    const enter_handle_login = (e) => {
        if(e.key==='Enter'){
            login_call_fn()
        } 
    }

    const login_call_fn = () => {
        if(email && password){
            set_page_loader({
                show: true,
                text: 'Loading...'
            });

            setTimeout(() => {
                general_fetch({url:'/user/login', body:{username:email, password:SHA512(password)}, return_raw_response: true})
                .then(response => {
                    if(response != "error"){
                            login_method = "email";
                            setTimeout(() => {
                                set_page_loader({
                                    show: false,
                                    text: ''
                                });
                                route_finder(response["attached_stores"])
                            }, 0);
                    }else{
                        return Promise.reject();
                    }
                })
                .catch(err=>{
                    if(!(err instanceof NetworkError)){
                        alert.error('Incorrect Email or Password')
                    }
                    set_page_loader({
                        show: false,
                        text: ''
                    });
                });
            }, 0);
        }else{
            alert.error('Please enter correct Email Id and Password.')
        }
    }

    /* const login_pop_up = async (social_site) => {
        var w = 550;
        var h = 600;
        var url = global.config.server_path+'/'+social_site;
        var title = 'Google Login';
     
        // Fixes dual-screen position
        var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : window.screenX;
        var dualScreenTop = window.screenTop != undefined ? window.screenTop : window.screenY;
     
        var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : window.screen.width;
        var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : window.screen.height;
     
        var left = ((width / 2) - (w / 2)) + dualScreenLeft;
        var top = ((height / 2) - (h / 2)) + dualScreenTop;
        var win = window.open(url, title, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
        // Puts focus on the win
        if (window.focus) {
            win.focus();
        }

        var timer = setInterval(async() => {
            if(win && win.closed) {
                win = undefined;
               // clearInterval(timer);
               try{
                    route_finder()
               }catch(err){
                   console.log(err)
                   alert.error("Request Failed. Try Again.")
                   set_page_loader({
                    show: false,
                    text: ''
                });
               }                
            }
        }, 100);
     
        return false;               
    } */

    const close_forgot_password_modal = () => {
        set_show_forgot_password_modal(false);
    }
    const open_forgot_password_modal = () => {
        set_show_forgot_password_modal(true);
    }

    const close_info_modal = () => {
        set_show_info_modal(false);
        set_info_message('')
    }
    const open_info_modal = () => {
        set_show_info_modal(true);
    }

    const go_back_to_normal = () => {
        set_login_modal_type('normal')
        set_login_state('signin')
    }

    // const onSignIn = (googleUser) => {
    //     var profile = googleUser.getBasicProfile();
    //     console.log('ID: ' + profile.getId()); // Do not send to your backend! Use an ID token instead.
    //     console.log('Name: ' + profile.getName());
    //     console.log('Image URL: ' + profile.getImageUrl());
    //     console.log('Email: ' + profile.getEmail()); // This is null if the 'email' scope is not present.
    // }
    
    const authorization_callback = async resp => {
        try {
            // if (resp.credential) {
            //     console.log('credential', resp.credential);
            // }
            let res = await general_fetch({
                url: '/social_login_google/stageadmin',
                body: {
                    credential: resp.credential,
                },
                return_response_code: true
            });
            // set_login_method("google")
            login_method = "google"

            if (res && res.response_code == 1) {
                res = res['data']

                if (res && res['user'] && !res['user']['orphan']) {
                    route_finder(res['attached_stores'])
                    // window.analytics.track("auto", {
                    //     "user_id": res['user'].id
                    // })
                }
                else if (res && res['user'] && res['user']['orphan'] == 1) {
                    set_is_user_loaded(true)
                    set_login_modal_type('new_to_inf')
                }

                // set_show_store_options_modal(true)
                // console.log('social login response', res);
            }else if(res && res.response_code){
                if(res.code == "USER_NOT_SIGNED_UP"){
                    // alert.error('')
                    // onclick_handleclose()
                    set_info_message('You have not signed up for infurnia. Contact our sales team to get started with Infurnia')
                    open_info_modal()
                }
            }
        } catch (err) {
            console.error(err);
        }
    }

    return !loaded ? "" : (
        <div style={styles.main_div}>
            {/* <div style={styles.layer}/> */}
            <Info_Modal open={show_info_modal} handle_close={close_info_modal} info={info_message}/>
            <Multilogin_alert_modal open={show_multilogin_modal} handle_close={() => set_show_multilogin_modal(false)}/>
            <Forgot_password_modal open={show_forgot_password_modal} handleclose={close_forgot_password_modal} set_page_loader={set_page_loader}/>
            <Store_options_modal open={show_store_options_modal} handle_close={close_store_options_modal} all_store_options={all_store_options} set_page_loader={set_page_loader} onclick_store={onclick_store} user_id={user_id}/>
            <Business_units_modal open={show_business_units_modal} handle_close={() => set_show_business_units_modal(false)} business_unit_options = {business_unit_options} onclick_business_unit = {onclick_business_unit} selected_store={selected_store} all_bu_options={all_bu_options}/>
            {/* <NoDesignerAccessModal open={show_no_designer_access_modal} handle_close={() => set_show_no_designer_access_modal(false)} selected_store={selected_store} logout={logout}/> */}
            <div style={{display:'flex', width:'100%', height:'100%', overflow:'auto', flexWrap:'wrap'}}>
                <div className={login_modal_type==='normal'?'d-none d-sm-none d-md-none d-lg-flex col-lg-6':'d-none'} id='image_cross_fading' style={{overflow:'hidden', alignItems:'center', display:'', justifyContent:'center'}}>
                    {/* Experience Infurnia */}
                    <img style={{height:'100vh'}} src='../../infkitchen.jpg'></img>
                    <img style={{height:'100vh'}} src='../../infkitchen2.jpg'></img>
                    <img style={{height:'100vh'}} src='../../infliving.jpg'></img>
                </div>
                {/* <div className={login_modal_type==='new_to_inf'?'col-12 col-lg-1 d-flex':'d-none'} style={{overflow:'hidden', alignItems:'center', display:'flex', justifyContent:'center', flexDirection:'column', padding:'15px 30px'}}></div> */}
                <div className={login_modal_type==='new_to_inf'?'col-12 col-lg-4':'d-none'} style={{overflow:'hidden', display:'flex', justifyContent:'center', flexDirection:'row', alignItems:'center'}}>
                    {/* Experience Infurnia */}
                    {/* <img style={{height:'100vh'}} src='../../infkitchen.jpg'></img> */}
                    <div className={login_modal_type==='new_to_inf'?'col-2 d-flex':'d-none'} style={{overflow:'hidden', alignItems:'center', display:'flex', justifyContent:'center', flexDirection:'column', height:'100%'}}></div>
                    <div className={login_modal_type==='new_to_inf'?'col-10 d-flex':'d-none'} style={{overflow:'hidden', alignItems:'center', display:'flex', justifyContent:'center', flexDirection:'column', backgroundColor:'rgba(251, 251, 251, 1)', padding:'20px 40px', height:'100%'}}>
                        <div style={{fontSize:'xx-large', fontWeight:'bold', letterSpacing:'1px'}}>
                            Welcome To
                        </div>
                        <div style={{backgroundColor:'inherit', textAlign:'center', marginBottom:'40px'}}> <img  height='56px' src='../../infurnia.png'/> </div>    
                        <div style={{fontStyle:'italic', fontSize:'20px'}}>
                            Your all-in-one 
                        </div>
                        <div style={{fontStyle:'italic', marginBottom:'60px', fontSize:'20px'}}>
                            Architecture Software
                        </div>
                        <div className='light_text'>
                            Join thousands of architects worldwide using Infurnia to create designs in a seamless and collaborative way
                        </div>
                    </div>
                </div>
            <div className={login_modal_type==='normal' ?'col-12 col-sm-12 col-md-12 col-lg-6':login_modal_type==='new_to_inf'?'col-12 col-lg-8':''} style={{ display:'flex', justifyContent:'center', alignItems:'center', /*position:"absolute", left:'calc((100% - 350px)/2)',top:'5%', height:'auto',*/ overflow:'auto', padding:'20px', flexDirection:login_modal_type==='normal' ?'column':'row'}}>
                
                <div style={{backgroundColor:'inherit', textAlign:'center', marginBottom:'40px', display:login_modal_type==='normal'?'block':'none'}}><img  height='56px' src={org_key_logo} /></div>    
                {/* <Card> */}
                    
                    <div style = {{ display: login_modal_type==='normal'? 'block':'none', padding:'40px 80px', fontSize:'14px', border:'1px solid rgba(230, 233, 238, 1)', borderRadius:'14px', boxShadow:'8px 8px 20px 6px rgba(184, 191, 202, 0.14)', width:'425px', maxWidth:'99%'}}>
                        <Row>
                            <Col style={{marginBottom: '30px'}} >
                                <span style={{fontSize:'24px', color:'#435A6F', fontWeight:'500',lineHeight:'36px', letterSpacing:'1.5px'}}>{org_key?"Login to your Organization":"Login to Infurnia"}</span>
                            </Col>
                        </Row>        
                        <Row style={{height:'40px'}}>
                            <Col>
                                <GoogleAuth 
                                    target={target} 
                                    id='login1'
                                    visible={login_modal_type == 'normal' ? true : false}
                                    google={google}
                                    authorization_callback={authorization_callback}
                                />
                                {/* <div class="g-signin2" data-onsuccess="onSignIn"></div> */}
                                {/* <div className='btn_google g-signin2' data-onsuccess="onSignIn" style={{margin:'0px 0px', backgroundColor:'white', border:0, fontWeight:'bold', width:'60px', height:'60px',boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.12)', borderRadius:'6px', color:'red', fontSize:'28px', padding:'15px'}} type="button" onClick={() =>login_pop_up('google')} > <img className='googleLoginLogo' src='../../GoogleLogo.svg'></img> </div> */}
                            </Col>
                        </Row>
                        {/* {!org_key?<Row>
                            <Col>    
                                <Button className='btn_login btn_linkedin' style={{margin:'15px 0px', backgroundColor:'#007bb6', border:0 , fontWeight:'bold'}} type="button" onClick={() =>login_pop_up('linkedin')} >Sign in with Linkedin</Button>
                            </Col>
                        </Row>:''} */}
                        {/* <Row>
                            <Col style={{padding: '10px'}}>
                                <span style={{fontSize:'18px'}}>or</span>
                            </Col>
                        </Row> */}

                        <Row style={{marginTop:'15px'}}>
                            <Col xs={5} style={{}} >
                                <hr style={{height:'1px', borderWidth:'0px', backgroundColor:'#A7A8B3', color:'#A7A8B3'}}></hr>
                            </Col>
                            <Col xs={2} style={{ display:'flex', alignItems:'center', justifyContent:'center'}} >
                                <span style={{color:'#A7A8B3', display:'flex', alignItems:'center', justifyContent:'center'}}> OR </span>
                            </Col>
                            <Col xs={5} style={{}} >
                                <hr style={{height:'1px', borderWidth:'0px', backgroundColor:'#A7A8B3', color:'#A7A8B3'}}></hr>
                            </Col>
                        </Row>       

                        <Row>
                            <Col style={{margin:'15px 0px 24px 0px'}} >
                                <span style={{fontSize:'14px', color:'#A7A8B3', lineHeight:'24px'}}>{org_key?"Login with your org credentials":"Login with your Email ID"}</span>
                            </Col>
                        </Row>    
                            
                        <Form role="form">
                            <Row>
                                <Col>
                                    <FormGroup style={{marginBottom:"16px"}}>
                                        <Input id="login_username" className='input_login' placeholder="Email" type="text" value={email?email:''} onChange={(e) => set_email(e.target.value)} onKeyUp={(e) => {if(e.key == 'Enter'){document.getElementById('login_password').select()}}}/>
                                    </FormGroup>
                                </Col>  
                            </Row>
                            <Row>
                                <Col>
                                    <FormGroup id='marginBottom0' className='input_login' style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                                        <Input id="login_password"  placeholder="Password" type= {show_password_normal ? "text" : "Password"} value={password?password:''}  onChange={(e) => set_password(e.target.value)} onKeyUp={(e)=>enter_handle_login(e)} />
                                        <i className={show_password_normal ? 'fa fa-eye-slash' : 'fa fa-eye' } onClick={() => {set_show_password_normal(!show_password_normal)}} style={{padding:'6px 12px', cursor:'pointer', color: '#C5C7CF'}}></i>
                                    </FormGroup>
                                </Col>  
                            </Row>
                            <Row>
                                <Col style={{textAlign:'left', fontSize:'14px', padding:'8px 12px', color:'#1588E0', marginBottom:'40px'}}>
                                    <span onClick={open_forgot_password_modal} style={{cursor:"pointer"}} className='forgot_password_hover'>Forgot Password?</span>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <Button  id="login_submit_normal" type="button" className=' btn_success' style={{ background:'linear-gradient(0deg, #213D5F, #213D5F)', textAlign:'center', border:0,borderRadius:'16px', width:'50%', marginBottom:'10px' }}  onClick={login_call_fn} >Login</Button>
                                </Col>
                            </Row>
                        </Form>

                        {/* {!org_key?(<Row>
                            <Col>
                                <Button className='btn_default' onClick={()=>{set_login_modal_type('new_to_inf');set_login_state('signup')}} style={{ margin:'25px 0px 0px 0px', width:'auto', backgroundColor:'white', color:'#333', border:'none',fontSize:'14px'}}  type="button">New to Infurnia? Sign Up</Button>
                            </Col>
                        </Row>):''} */}
                        
                    </div>
                    
                    {/* Removing Sign Up */}
                    {/* {!org_key?(<Row className={login_modal_type==='normal'?'d-block':'d-none'} style={{marginTop: '25px'}}>
                        <Col>
                            <span className='light_text' style={{ width:'auto', backgroundColor:'white', border:'none',fontSize:'14px'}}>New to Infurnia? </span>
                            <span onClick={()=>{set_login_modal_type('new_to_inf');set_login_state('signup')}} style={{ cursor:'pointer', width:'auto', backgroundColor:'white', color:'#333', border:'none',fontSize:'14px', textDecoration:'underline', fontStyle:'italic', color:'rgba(0, 120, 255, 1)'}}>Signup</span>
                        </Col>
                    </Row>):''} */}
                    
                    <div style = {{ display: login_modal_type==='new_to_inf'? 'flex':'none', width:'100%', height:'100%', flexWrap:'wrap', alignItems:'center'}}>
                        
                        <div style={{width:'100%'}}>
                        <div className='col-12' style={{alignItems:'center', color: 'rgba(103, 104, 120, 1)', fontSize:'20px', marginBottom:'20px'}}>
                            <span>Your account is not part of an organization yet.</span>
                        </div>
                        <div className='col-12' style={{alignItems:'center', color: 'rgba(167, 168, 178, 1)', marginBottom:'20px'}}>
                            <span>Contact our sales team or your Infurnia account manager to get your organization set up.</span>
                        </div>
                        <div className='col-12' style={{alignItems:'center', color: 'rgba(167, 168, 178, 1)'}}>
                            <span>If you are already a part of organization partnered with infurnia please click here to </span>
                            <span onClick={is_user_loaded ? logout : go_back_to_normal} style={{color:'rgba(0, 120, 255, 1)', fontSize:'14px', fontStyle:'italic', textDecoration:'underline'}}  type="button">Login</span>
                        </div>
                        </div>


                        {/* <Row>
                            <Col>
                                <span onClick={go_back_to_normal} style={{ padding:'5px', color:'#5092BD', fontSize:'14px',fontWeight:'bold'}}  type="button">Go back to Login</span>
                            </Col>
                        </Row> */}
                        
                    </div>
                   
                    
                {/* </Card> */}
            </div>
            </div>
        </div>    
    );
}

export default Sign_up;

